<template>
	<div
		v-bind:class="[
			{
				'builder-element': !onPreview,
				'text-left': node.options.align === 'left',
				'text-center': node.options.align === 'center',
				'text-right': node.options.align === 'right',
				'hide-desktop': node.options.visible_desktop,
				'hide-mobile': node.options.visible_mobile,
			},
			node.class,
		]"
		:id="node.id"
		:data-key="node.key"
		:data-elIcon="node.icon"
		:data-elName="node.name"
		:data-type="node.type"
		@click="onNodeClick(node)"
		:style="getWrapperStyle(node)"
	>
		<NodeAction :node="node" component="element" v-if="!onPreview" />

		<a
			v-if="node.options && node.options.link"
			:href="node.options.link"
			@click.stop.prevent="onNodeClick(node)"
			:target="node.options.inNewTab ? '_blank' : '_self'"
		>
			<!-- <img
				:class="`img ${node.class}`"
				:src="imageUrl"
				:style="style"
				loading="lazy"
			/> -->
			<auto-image
				:path="imageUrl"
				:classes="`img ${node.class}`"
				:styles="style"
				:parentWidth.sync="parentWidth"
				:isOptimize="isOptimizeImages"
			/>
		</a>
				<!-- :width="width"
				:height="height" -->

		<!-- <img
			v-else
			:class="`img ${node.class}`"
			:src="imageUrl"
			:style="style"
			loading="lazy"
		/> -->

		<auto-image
			v-else
			:path="imageUrl"
			:classes="`img ${node.class}`"
			:styles="style"
			:parentWidth.sync="parentWidth"
			:isOptimize="isOptimizeImages"
		/>
	</div>
</template>

<script>
import NodeAction from '@/components/funnels/pagebuilder/nodes/NodeAction.vue';
import AutoImage from '@/components/funnels/pagebuilder/parts/AutoImage.vue';
import {
	getNodeStyle,
	getCurrentElementWidth,
	// eslint-disable-next-line
} from '@/lib/helper';

export default {
	name: 'NodeImage',
	props: ['node', 'onPreview', 'previewDevice', 'settings'],
	components: {
		NodeAction,
		AutoImage,
	},
	data() {
		return {
			parentWidth: null,
		};
	},
	watch: {},
	mounted() {
		this.$nextTick(
			// eslint-disable-next-line
			function() {
				this.getElementWidth();
			},
		);
	},
	methods: {
		getWrapperStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'margin',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},
		getStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'padding',
				'border',
				'box-shadow',
				'max-width',
				'width',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},
		onNodeClick(node) {
			this.handleAction('edit', node);
		},
		handleAction(type, node) {
			this.$bus.$emit('action-element', type, node);
		},
		getElementWidth() {
			let width = 0;
			if (this.node && this.node.id && this.node.id !== '') {
				width = getCurrentElementWidth(`#${this.node.id}`);
			}
			this.parentWidth = width;
		},
	},
	computed: {
		style() {
			return this.node ? this.getStyle(this.node) : {};
		},
		width() {
			const options = this.node.options;
			const device = this.previewDevice;
			let width = '';
			if (device === 'desktop') {
				const fixedWidthUnit = options && options.widthUnit && options.widthUnit !== '' ? options.widthUnit : '%';
				width = options && options.width && options.width !== ''
					? `${options.width}${fixedWidthUnit}`
					: '';
			} else if (device === 'mobile') {
				const fixedWidthUnit = options && options.mobileWidthUnit && options.mobileWidthUnit !== '' ? options.mobileWidthUnit : '%';
				width = options && options.mobileWidth && options.mobileWidth !== ''
					? `${options.mobileWidth}${fixedWidthUnit}`
					: '';
			}
			return width;
		},
		height() {
			return this.node.options ? this.node.options.height : '';
		},
		imageUrl() {
			const placeholderWidth = this.width && this.width !== '' ? this.width : '600';
			const placeholderHeight = this.height && this.height !== '' ? this.height : '400';
			const placeholder = `https://place-hold.it/${placeholderWidth}x${placeholderHeight}`;
			const imageUrl = this.node?.options?.src ?? placeholder;
			return imageUrl;
		},
		isOptimizeImages() {
			// eslint-disable-next-line
			return this.settings?.optimize_images ?? false;
		},
	},
};
</script>
<style lang="scss">
.img {
	max-width: 100%;
}
</style>
